import React from "react";
import ActiveProspecting from './ActiveProspecting';
import Origens from './Origens';
import SocialSelling from './SocialSelling';
import ContasPagarCategorias from './ContasPagarCategorias';
import ContasReceberCategorias from './ContasReceberCategorias';

var SECTION_MAP = {
  'origens': Origens,
  'cadencias-prospeccao': ActiveProspecting,
  'cadencias-social-selling': SocialSelling,
  'categorias-contas-pagar': ContasPagarCategorias,
  'categorias-contas-receber': ContasReceberCategorias,
};

var SystemVariables = function(props) {
  var section = props.section || 'origens';
  var Component = SECTION_MAP[section] || Origens;

  return React.createElement(Component, {
    addTrigger: props.addTrigger || 0,
    searchTerm: props.searchTerm || ''
  });
};

export default SystemVariables;
